import axios from 'axios'

// 创建axios实例
const service = axios.create({
  baseURL: window.$liveApi.base_url, // api 的 base_url
  withCredentials: true,
  timeout: 900000 // 请求超时时间
})

// request拦截器
service.interceptors.request.use(
  config => {
    // if (getToken()) {
    //   config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
    // }
    // config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
    return config
  },
  error => {
    console.error(error) // for debug
    Promise.reject(error)
  }
)

// response 拦截器
service.interceptors.response.use(
  response => {
    let res = response.data
    if (+res.code !== 0 && res.message) {
      window.liveVue.$toast(res.message)
    }
    return res
  },
  error => {
    console.error(error)
    return Promise.reject(error)
  }
)
export default service
